import _get from 'lodash/get';

import { localStore, logError, post } from 'utils';
import { STORAGE_KEYS } from 'utils/DICTIONARY';

export function setAccessRefreshToken(token) {
  if (!token) return;
  localStore.put(STORAGE_KEYS.REFRESH_TOKEN, token);
}

export function generateRefreshToken(callback = () => {}) {
  const refreshToken = localStore.get(STORAGE_KEYS.REFRESH_TOKEN);

  if (!refreshToken) {
    return callback(null); // Assume no error and skip further processing
  }

  post(
    { apiKey: 'auth.refreshToken', noTokenRequired: true },
    { params: { refresh: refreshToken }, config: { withCredentials: true } }
  )
    .then(({ data }) => {
      setAccessRefreshToken(_get(data, 'refresh', ''));
      callback(null, data);
    })
    .catch(err => {
      logError(err);
      callback(err, null);
    });
}
